import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {SaleInvoiceDataService} from './impl/service/ngrx/saleInvoicedata.service';
import {SaleInvoiceConfigurationModule} from './modules/configuration/saleInvoiceConfiguration.module';
import {SaleInvoiceRepository} from './impl/service/ngrx/saleInvoice.repository';
import {errorMessages} from "../../../core/error/errorMessages";

@NgModule({
    imports: [
        SaleInvoiceConfigurationModule,
    ]
})
export class SaleInvoiceModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: SaleInvoiceRepository,
                dataService: SaleInvoiceDataService,
    ) {

        entityDataService.registerServices({
            SaleInvoice: dataService,
        });

        entityServices.registerEntityCollectionServices({
            SaleInvoice: service,
        });

        errorMessages.set('SALE_INVOICE_SEND_EMAIL_NO_EMAIL', 'Aucune adresse e-mail connue');
    }
}
